import { TenantConfigViewData } from 'src/dao/tenantConfigClient';
import type { SortOption } from 'src/common-ui/components/CompanionListView/CompanionListView.types';
import { pick } from 'lodash';

export interface ParseResult {
  defaultSort: SortOption;
  sortOptions: SortOption[];
}

export function parseSortConfig(sortConfig: TenantConfigViewData): ParseResult {
  let defaultKey: string;
  if (sortConfig.defaults) {
    defaultKey = sortConfig.defaults.dataIndex;
  } else {
    defaultKey = sortConfig.view[0].dataIndex;
  }
  const sortOptions = sortConfig.view.map((option) => pick(option, 'dataIndex', 'text'));
  //if can't find the default options, fall back to the first one
  const defaultSort = sortOptions.find((option) => option.dataIndex === defaultKey) || sortOptions[0];

  return {
    defaultSort,
    sortOptions,
  };
}
